import moment from "moment";

export const calculateDollarSalesPerMonth = (data) => {
    return data.slice(1).reduce((acc, item) => {
      const fecha = item[0];
      const month = moment(fecha, 'DD/MM/YYYY').format('MM');
      const sale = parseFloat(item[2]);

      acc[month] = acc[month] || { total: 0, count: 0 };
      acc[month].total += sale;
      acc[month].count++;

      return acc;
    }, {})

  }

export const calculateAveragePerMonth = (salesPerMonth) => {
    return Object.keys(salesPerMonth).reduce((result, key) => {
      const average = salesPerMonth[key].total / salesPerMonth[key].count || 0;
      result[key] = parseFloat(average.toFixed(2));
      return result;
    }, {});    
  };

export const convertToArray = (average) => {
    const months = {
      "01": "Enero",
      "02": "Febrero",
      "03": "Marzo",
      "04": "Abril",
      "05": "Mayo",
      "06": "Junio",
      "07": "Julio",
      "08": "Agosto",
      "09": "Sept.",
      "10": "Oct.",
      "11": "Nov.",
      "12": "Dic."
    };

    return Array.from({ length: 12 }, (_, index) => {
      const monthNum = (index + 1).toString().padStart(2, '0');
      const monthName = months[monthNum];
      return {
          name: monthName || `Mes ${monthNum}`,
          average: average[monthNum] || 0
      };
  });
  }

  const calculateResult = (average, total) => {
    if (average !== 0 && total !== 0) {
        const result = parseFloat(total) / average;
        return parseFloat(result.toFixed(2));
    }
    return 0;
};

export const convertToDollars = (equalArray, copyData) => {
return equalArray.map(({ name, average }) => {
  const totalObj = copyData.find(item => item.name === name);
    if (totalObj) {
        return { name, Cuota1: calculateResult(average, totalObj.Cuota1), OtrasCuotas: calculateResult(average, totalObj.OtrasCuotas), averageMonth: average };
    }
    return null;
}).filter(Boolean);
}

export const convertHistoricDataToDollars = (historicMarketData, graphicData) => {
  const salesByYearMonth = (historicMarketData || []).slice(1).reduce((accumulatedSales, currentRecord) => {
    const recordDate = currentRecord[0];
    const yearMonth = moment(recordDate, 'DD/MM/YYYY').format('YYYY-MM');
    const dollarRate = parseFloat(currentRecord[2]);

    if (!isNaN(dollarRate) && dollarRate > 0) {
      accumulatedSales[yearMonth] = accumulatedSales[yearMonth] || { total: 0, count: 0 };
      accumulatedSales[yearMonth].total += dollarRate;
      accumulatedSales[yearMonth].count += 1;
    }
    return accumulatedSales;
  }, {});

  const averageRateByYearMonth = {};
  Object.keys(salesByYearMonth).forEach((yearMonthKey) => {
    const monthStats = salesByYearMonth[yearMonthKey];
    averageRateByYearMonth[yearMonthKey] = parseFloat(
      (monthStats.total / monthStats.count).toFixed(2)
    );
  });

  return graphicData.map((dataItem) => {
    const monthNumber = String((dataItem.monthIndex ?? 0) + 1).padStart(2, '0');
    const yearMonthKey = `${dataItem.year}-${monthNumber}`;
    const averageDollarRate = averageRateByYearMonth[yearMonthKey] || 0;

    if (averageDollarRate > 0) {
      const convertedCuota1 = parseFloat(((dataItem.Cuota1 || 0) / averageDollarRate).toFixed(2));
      const convertedOtrasCuotas = parseFloat(((dataItem.OtrasCuotas || 0) / averageDollarRate).toFixed(2));
      return {
        ...dataItem,
        Cuota1: convertedCuota1,
        OtrasCuotas: convertedOtrasCuotas,
        Total: parseFloat((convertedCuota1 + convertedOtrasCuotas).toFixed(2)),
        averageMonth: averageDollarRate,
      };
    }
    return dataItem;
  });
};